/**
 * Core-100 R2 — CORE-BE-GAP-001: why a carried ticket is here, in people's words.
 * The reason and its basis are the database's (`tickets.carry_reason[_basis]`, set at the carry
 * or stated by the front office through `state_carry_reason`); this only words them. A derived
 * reason says it was read from the ticket's state; no reason says so rather than guessing.
 */
export const CARRY_REASONS = [
  'waiting_on_customer',
  'waiting_on_parts',
  'ran_long',
  'intentionally_continued',
  'capacity',
  'other',
] as const;
export type CarryReason = typeof CARRY_REASONS[number];

export const CARRY_REASON_LABEL: Record<CarryReason, string> = {
  waiting_on_customer: 'Waiting on the customer',
  waiting_on_parts: 'Waiting on parts',
  ran_long: 'The work ran long',
  intentionally_continued: 'Planned multiday repair',
  capacity: 'No time left today',
  other: 'Other',
};

export function describeCarryReason(reason: string | null | undefined, basis: string | null | undefined): string {
  if (!reason || !(reason in CARRY_REASON_LABEL)) return 'Carried over — reason not recorded';
  const label = CARRY_REASON_LABEL[reason as CarryReason];
  return basis === 'derived' ? `Carried over — ${label} (from the ticket's state)` : `Carried over — ${label}`;
}
